import { useEffect, useState } from "react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import "../../assets/css/console.css";
import { Badge } from "reactstrap";

function Console({
  result,
  setConsoleHeight,
  consoleHeight,
  minimumHeight = 60,
}) {
  const [isResizing, setIsResizing] = useState(false);

  const startResizing = () => setIsResizing(true);
  const stopResizing = () => setIsResizing(false);

  const handleResizing = (e) => {
    if (isResizing) {
      const newHeight = Math.max(
        50,
        window.innerHeight - e.clientY - minimumHeight
      ); // Limite mínimo de 50px
      setConsoleHeight(newHeight);
    }
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleResizing);
    window.addEventListener("mouseup", stopResizing);

    return () => {
      window.removeEventListener("mousemove", handleResizing);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing]);

  return (
    <div
      className="console-depurer"
      style={{
        height: consoleHeight,
        borderTop: "thin solid",
        width: "100%",
        position: "relative",
        overflow: "auto",
      }}
    >
      <div
        style={{
          height: "5px",
          backgroundColor: "#ccc",
          position: "absolute",
          top: -2,
          width: "100%",
          cursor: "row-resize",
          userSelect: "none",
        }}
        onMouseDown={startResizing}
      />

      <div className="active-code">
        <span className="function-name console-title">
          Console de Depuração
        </span>
        <a
          onClick={() =>
            setConsoleHeight(
              consoleHeight <= minimumHeight ? 150 : minimumHeight - 4
            )
          }
        >
          {consoleHeight > minimumHeight ? (
            <MdArrowDropDown size={25} />
          ) : (
            <MdArrowDropUp size={25} />
          )}
        </a>
      </div>

      <div className="console-content">
        {result ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: 10,
              paddingBottom: 5,
              paddingTop: 5,
            }}
          >
            {result.split("\n").map((e) => (
              <span className="console-line">{e}</span>
            ))}
          </div>
        ) : (
          <p style={{ opacity: 0.3, fontStyle: "italic" }}>
            Neste console, você poderá visualizar tanto os resultados quanto os
            erros gerados pela execução da função.
          </p>
        )}
      </div>
    </div>
  );
}

export default Console;
